module.exports = __webpack_public_path__ + "static/media/nintendo-switch-logo-red.16b8e3d2.jpg";